import { chakra } from "@chakra-ui/react";
import * as React from "react";

export const LinkedIn = (props: any) => (
  <chakra.svg
    width="28px"
    height="29px"
    viewBox="0 0 28 29"
    fill="none"
    flexShrink={0}
    {...props}
  >
    <g id="linkedin" clipPath="url(#clip0_1046_35418)">
      <path
        id="Vector"
        d="M20.9974 4.90332H6.9974C5.70873 4.90332 4.66406 5.94799 4.66406 7.23665V21.2367C4.66406 22.5253 5.70873 23.57 6.9974 23.57H20.9974C22.2861 23.57 23.3307 22.5253 23.3307 21.2367V7.23665C23.3307 5.94799 22.2861 4.90332 20.9974 4.90332Z"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M9.33594 13.0693V18.9027"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M9.33594 9.56934V9.581"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M14 18.9027V13.0693"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M18.6667 18.9027V15.4027C18.6667 14.7838 18.4208 14.1903 17.9832 13.7528C17.5457 13.3152 16.9522 13.0693 16.3333 13.0693C15.7145 13.0693 15.121 13.3152 14.6834 13.7528C14.2458 14.1903 14 14.7838 14 15.4027"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_35418">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0 0.236328)"
        />
      </clipPath>
    </defs>
  </chakra.svg>
);
